module.exports = __webpack_public_path__ + "fonts/Roboto-Light.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Light.woff2
// module id = 264
// module chunks = 0